import ReportService from '../services/ReportService';

const ADMIN_COMPANY_STORAGE_KEY = 'reportAdminCompanyScope';

export const ALL_COMPANIES_TOKEN = '__ALL__';

export const getReportUserDetails = () => JSON.parse(localStorage.getItem('userDetails') || '{}');

export const isReportAdmin = (userDetails) => String(userDetails?.Group || '').toLowerCase() === 'admin';

export const getReportCompanyCode = (userDetails) => userDetails?.CompanyCode || userDetails?.SirketKodu || null;

export const getStoredAdminCompanyCode = () => sessionStorage.getItem(ADMIN_COMPANY_STORAGE_KEY) || null;

export const setStoredAdminCompanyCode = (companyCode) => {
  const trimmed = String(companyCode || '').trim();
  if (trimmed) {
    sessionStorage.setItem(ADMIN_COMPANY_STORAGE_KEY, trimmed);
  } else {
    sessionStorage.removeItem(ADMIN_COMPANY_STORAGE_KEY);
  }
};

export const clearStoredAdminCompanyCode = () => {
  sessionStorage.removeItem(ADMIN_COMPANY_STORAGE_KEY);
};

export const getDefaultAdminCompanyCode = (branches) => {
  if (!Array.isArray(branches) || branches.length === 0) {
    return null;
  }
  if (branches.length > 1) {
    return ALL_COMPANIES_TOKEN;
  }
  const codes = [...new Set(branches.map((branch) => branch.SirketKodu).filter(Boolean))];
  return codes[0] || null;
};

export const getUniqueCompaniesFromBranches = (branches) => {
  const map = new Map();
  if (!Array.isArray(branches)) {
    return [];
  }
  branches.forEach((branch) => {
    const code = String(branch.SirketKodu || '').trim();
    if (!code || map.has(code)) {
      return;
    }
    map.set(code, {
      SirketKodu: code,
      SirketAdi: branch.SirketAdi || code,
    });
  });
  return Array.from(map.values());
};

export const filterBranchesByCompany = (branches, companyCode) => {
  if (!Array.isArray(branches)) {
    return [];
  }
  const trimmed = String(companyCode || '').trim();
  if (!trimmed || trimmed === ALL_COMPANIES_TOKEN) {
    return branches;
  }
  return branches.filter((branch) => branch.SirketKodu === trimmed);
};

export const getReportBranchSelectCompanyCode = ({
  needsCompanyPicker,
  draftAdminCompanyCode,
  adminCompanyCode,
  effectiveCompanyCode,
}) => {
  if (!needsCompanyPicker) {
    return effectiveCompanyCode;
  }

  const draft = String(draftAdminCompanyCode || '').trim();
  if (draft) {
    return draft;
  }

  const admin = String(adminCompanyCode || '').trim();
  if (admin) {
    return admin;
  }

  return effectiveCompanyCode || ALL_COMPANIES_TOKEN;
};

const normalizeBranchListResponse = (response) => {
  if (!response || response.status !== 200) {
    return [];
  }

  const payload = response.data;
  if (Array.isArray(payload)) {
    return payload;
  }
  if (Array.isArray(payload?.data)) {
    return payload.data;
  }
  if (Array.isArray(payload?.items)) {
    return payload.items;
  }
  return [];
};

export const resolveEffectiveCompanyCode = (
  sessionCompanyCode,
  branchCode,
  branches,
  adminSelectedCompanyCode = null
) => {
  const trimmedSession = String(sessionCompanyCode || '').trim();
  if (trimmedSession) {
    return trimmedSession;
  }

  const trimmedBranch = String(branchCode || '').trim();
  if (trimmedBranch && Array.isArray(branches)) {
    const branch = branches.find((item) => item.SubeKodu === trimmedBranch);
    const fromBranch = String(branch?.SirketKodu || '').trim();
    if (fromBranch) {
      return fromBranch;
    }
  }

  const trimmedAdmin = String(adminSelectedCompanyCode || '').trim();
  if (trimmedAdmin) {
    return trimmedAdmin;
  }

  return null;
};

export const resolveCompanyCodeForBranch = (companyCode, branchCode, branches, adminSelectedCompanyCode = null) => (
  resolveEffectiveCompanyCode(companyCode, branchCode, branches, adminSelectedCompanyCode)
);

export const loadReportBranches = async (token, userDetails = getReportUserDetails()) => {
  const companyCode = getReportCompanyCode(userDetails);
  const admin = isReportAdmin(userDetails);

  if (!admin && !companyCode) {
    return [];
  }

  const requestParams = { token };
  if (companyCode && !admin) {
    requestParams.CompanyCode = companyCode;
  }

  const response = await ReportService.company.getBranches(requestParams);
  return normalizeBranchListResponse(response);
};
